import { ComplementOriginEnum } from '../WorkOrders/WorkOrders.types';
import { WorkOrderComplementStatus } from '../WorkOrdersComplements/WorkOrdersComplements.types';

export enum WorkOrderTrackingCalendarDateType {
  Entry = 'domain.enums.work_order_date_type.entry',
  Authorization = 'domain.enums.work_order_date_type.authorization',
  Close = 'domain.enums.work_order_date_type.close',
  Estimated = 'domain.enums.work_order_date_type.estimated',
  Return = 'domain.enums.work_order_date_type.return',
}

export interface WorkOrderTrackingCalendarQueryParams {
  dateType: WorkOrderTrackingCalendarDateType;
  startDate: string;
  endDate: string;
  complementOrigin?: ComplementOriginEnum;
}

export interface WorkOrderTrackingCalendar {
  workOrderId: number;
  complementId: number;
  status: WorkOrderComplementStatus;
  complementIdentifier: string;
  complementOrigin?: ComplementOriginEnum;
  authorizationDate?: string;
  closingDate?: string;
  entryDate?: string;
  estimatedLeaveDate?: string;
  returnDate?: string;
}

export interface WorkOrderTrackingCalendarComplement {
  workOrderId: number;
  complementId: number;
  complementOrigin: ComplementOriginEnum;
  total: number;
  partsTotal: number;
  servicesTotal: number;
  companyName: string;
  clientName: string;
  vehicleName?: string;
  licensePlate?: string;
  entryDate: string;
  authorizationDate?: string;
  closingDate?: string;
  estimatedLeaveDate?: string;
  returnDate?: string;
}
